import type { IDependentControl } from '~/presentation/reports/common/type';

import { useControlDataChange } from '~/presentation/reports/common';
import { DeleteIcon } from '@shopify/polaris-icons';
import { WrapperAction } from './WrapperAction';
import { Icon } from '@shopify/polaris';

interface DeleteActionProps {
  dependentControls?: IDependentControl[];
  uid?: string;
  onDelete?: () => void;
}

export const DeleteAction: React.FC<DeleteActionProps> = ({ dependentControls, uid, onDelete }) => {
  const { emitControlChange, emitDeleteControlUI, emitResetControlData } = useControlDataChange();

  if (!dependentControls?.length) return null;

  const handleDelete = (e: React.MouseEvent) => {
    if (!uid) return;

    e.stopPropagation();

    const dependentControl = dependentControls[0];
    if (!Array.isArray(dependentControl.value)) return;

    emitResetControlData([uid]);

    emitControlChange({
      [dependentControl.id]: dependentControl.value?.filter((item) => item !== uid),
    });

    onDelete?.();
    emitDeleteControlUI(uid);
  };

  return (
    <WrapperAction onClick={handleDelete}>
      <Icon source={DeleteIcon} />
    </WrapperAction>
  );
};
